import React, { useRef, useState, useContext, useEffect } from 'react';
import '../styles/Login.css';
import { useNavigate } from 'react-router-dom';
import PageContainer from '../components/container/PageContainer';
import Input from '../components/inputs/Input';
import { EmptyLoginRequest, LoginRequest } from '../types/auth/LoginRequest';
import { Col, Form, Row } from 'react-bootstrap';
import { login } from '../services/api';
import { AuthContext } from '../context/AuthContext';
import useValidation from '../hooks/useValidation';
import { LOGIN_VALIDATION } from '../constants/validation/LoginValidation';
import { focusNextInput } from '../utils/focusNextInput';

const Login = () => {
  const nav = useNavigate();
  const authContext = useContext(AuthContext);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [request, setRequest] = useState<LoginRequest>(EmptyLoginRequest);
  const { validate } = useValidation(LOGIN_VALIDATION);

  // Enterでフォーカス移動
  const ref = useRef<(HTMLInputElement | HTMLButtonElement)[]>([]);
  useEffect(() => {
    if (ref.current[0]) {
      ref.current[0].focus();
    }
  }, []);

  const handleLogin = async (e: React.FormEvent) => {
    try {
      const validationError = validate(request);
      if (validationError) {
        setErrorMessage(validationError);
        return;
      }
      const response = await login(request);
      authContext?.login(response.accessToken, response.role);
      if (response.role === 'ADMIN') {
        nav('/admin/costaccounting/tokyo');
        return;
      }
      if (response.role === 'USER') {
        nav('/report');
        return;
      }
    } catch (error: any) {
      setErrorMessage(error.response?.data?.message);
      return;
    }
  };

  return (
    <main className="login-root">
      <h1 className="login-title">業務基幹システム</h1>

      <div className="login-area">
        <Row className="my-3 align-items-center">
          <Col className="login-label-col">
            <Form.Label className="fs-6 login-label">社員コード</Form.Label>
          </Col>
          <Col>
            <Input
              value={request.employeeCode}
              onChange={(e) =>
                setRequest({ ...request, employeeCode: e.target.value })
              }
              className="login-input"
              ref={(el) => {
                if (el && !ref.current.includes(el)) ref.current.push(el);
              }}
              onKeyDown={(e) => focusNextInput(e, ref, 0)}
            />
          </Col>
        </Row>

        <Row className="mb-2 align-items-center">
          <Col className="login-label-col">
            <Form.Label className="fs-6 login-label">パスワード</Form.Label>
          </Col>
          <Col>
            <Input
              type="password"
              value={request.password}
              onChange={(e) =>
                setRequest({ ...request, password: e.target.value })
              }
              className="login-input"
              ref={(el) => {
                if (el && !ref.current.includes(el)) ref.current.push(el);
              }}
              onKeyDown={(e) => focusNextInput(e, ref, 1)}
            />
          </Col>
        </Row>

        {errorMessage && (
          <div className="error-message text-center mb-2 auth-error">
            {errorMessage}
          </div>
        )}

        <button
          className="login-button"
          type="button"
          onClick={handleLogin}
          ref={(el) => {
            if (el && !ref.current.includes(el)) ref.current.push(el);
          }}
          disabled={!request.employeeCode || !request.password}
        >
          ログイン
        </button>

        <div className="version text-center">ver:1.0.0</div>
      </div>
    </main>
  );
};

export default Login;
